import { render, staticRenderFns } from "./vacancyStats.vue?vue&type=template&id=0dab7f80&"
import script from "./vacancyStats.vue?vue&type=script&lang=js&"
export * from "./vacancyStats.vue?vue&type=script&lang=js&"
import style0 from "./vacancyStats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports